









































































import { Component, Prop, Vue } from "vue-property-decorator";
import VueElementLoading from "vue-element-loading";
import { mapState } from "vuex";

@Component({
	inheritAttrs: false,
	components: {
		VueElementLoading
	},
	computed: {
		...mapState("pickup", ["jwt", "eform", "autocomplete","urlLogo"])
	}
})
export default class ThumbnailPreview extends Vue {
	jwt: string;
	eform: any;
	autocomplete: string;
	actionUrl: string = "";

	get editUrl() {
		const eformUrl = window.sichern.eformsURL;

		const eformPort = window.sichern.eformsPORT;

		return `${eformUrl}:${eformPort}${this.eform.eformEdit}`;
	}

	get viewUrl() {
		const eformUrl = window.sichern.eformsURL;

		const eformPort = window.sichern.eformsPORT;

		return `${eformUrl}:${eformPort}${this.eform.eformView}`;
	}

	callForm(action) {
		const form = document.getElementById(`${action}`) as HTMLFormElement;

		form.submit();
	}
}
